"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.subscribeHubspot = subscribeHubspot;

var _querystring = require("querystring");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HUBSPOT_LOAD = "ms/gallery/load";
var HUBSPOT_LOAD_SUCCESS = "ms/gallery/load_success";
var HHUBSPOT_LOAD_FAIL = "ms/gallery/load_fail";

var initialState = {
  loading: false,
  loaded: false,
  data: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case HUBSPOT_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false
      });
    case HUBSPOT_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case HHUBSPOT_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    default:
      return state;
  }
}

function subscribeHubspot(email) {
  return function (dispatch, getState) {
    var externalCall = true;
    return dispatch({
      types: [HUBSPOT_LOAD, HUBSPOT_LOAD_SUCCESS, HHUBSPOT_LOAD_FAIL],
      promise: function promise(client) {
        return client.post("/v1/email/subscribe/hubspot", {
          data: { email: email },
          externalCall: externalCall
        });
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/hubspot.js
// module id = 623
// module chunks = 0